import React from 'react';
import { Button, Card, Spinner } from 'react-bootstrap';
import { FaDatabase, FaChartBar } from 'react-icons/fa';
import { BiMessageAltError } from 'react-icons/bi';
import DbSourceHelper from './DbSourceHelper';
import S3SourceHelper from './S3SourceHelper';
import NoSqlSourceHelper from './NoSqlSourceHelper';
import TestResults from './TestResults';
import DiscoveryTooltip from 'DiscoveryTooltip';
const SourcePanel = ({ error, testConnectionHandler, profileHandler, type, connectionTest, connectionName, currentState }) => {
  // Every source type has a server-side test path now: file sources via the VFS test
  // endpoint, mongodb via the NOSQL test-connection support added with mongo enablement.
  const testing = currentState === 'testing';
  const profiling = currentState === 'profiling';
  const busy = testing || profiling;
  const tooltipText = testing ? 'Running data source test..' : 'Click to start data source test.';

  return (
    <Card className="shadow-sm widget-card">
      <div className="d-flex flex-row p-2">
        <div className="flex-grow-1 d-flex flex-row justify-content-end">
          {profileHandler && (
            <DiscoveryTooltip
              placement='top'
              text={profiling
                ? 'Running profile..'
                : 'Collect schema / file-folder metadata for this data source.'}
            >
              <div>
                <Button
                  disabled={busy}
                  onClick={async () => await profileHandler()}
                  className='pr-4 pl-4 mr-2 float-right'
                  variant='outline-secondary'
                >
                  <span>
                    { profiling ? (
                      <Spinner className='mr-2' size='sm' animation='border' />
                    ) : (
                      <FaChartBar className='mr-2' />
                    )}
                    { profiling ? 'Profiling' : 'Profile' }
                  </span>
                </Button>
              </div>
            </DiscoveryTooltip>
          )}
          <DiscoveryTooltip
            placement='top'
            text={tooltipText}
          >
            <div>
              <Button
                disabled={busy}
                onClick={async () => await testConnectionHandler()}
                className='pr-4 pl-4 float-right'
                variant='outline-secondary'
              >
                <span>
                  { testing ? (
                    <Spinner className='mr-2' size='sm' animation='border' />
                  ) : (
                    <FaDatabase className='mr-2' />
                  )}
                  { testing ? 'Validating' : 'Test' }
                </span>
              </Button>
            </div>
          </DiscoveryTooltip>
        </div>
      </div>
      <PanelContent
        connectionTest={connectionTest}
        type={type}
        error={error}
        connectionName={connectionName}
      />
    </Card>
  );
}

const ConnectionError = (props) => (
  <div>
    <Card.Body className='error-message-card'>
      <div>
        <div>
          <div className="text-center">
            <BiMessageAltError color="#D9DDE3" size="200" /> <br />
          </div>
          <div className="text-center">
            <p className="text-secondary">{props.error}</p>
          </div>
        </div>
      </div>
    </Card.Body>
  </div>
);

const PanelContent = (props) => {
  const type = props.type;
  const connectionTest = props.connectionTest;
  const error = props.error;
  const connectionName = props.connectionName;

  return (
    <div className='d-flex flex-column'>
      {(() => {
        if (error) {
          return (
            <ConnectionError
              error={error || connectionTest.message}
            />
          )
        }

        if (
          connectionTest.status === 'SUCCEEDED' ||
          connectionTest.status === 'FAILED' ||
          connectionTest.jobRunState === 'FAILED'
        ) {
          return (
            <TestResults 
              testResults={connectionTest}
              type={type}
              connectionName={connectionName}
            />
          );
        }

        switch (type) {
          case 's3':
            return <S3SourceHelper />;
          case 'mongodb':
            return <NoSqlSourceHelper />;
          default:
            return <DbSourceHelper />;
        }
      })()}
    </div>
  );
}

export default SourcePanel;